import { isGodMode, getGodModeToken, overlayGet, overlaySet, overlayRemove } from '../godMode/session';

const LOCAL_STORAGE_KEYS = {
    TOKEN: "token",
    USER: "user",
    USER_ID: "userId",
    COMPANY_ID: "companyId",
    COMPANY_NAME: "companyName",
    // Identité hydratée par UserContext/CompanyContext au mount : DOIT être vidée à la
    // déconnexion, sinon l'ancien compte s'affiche après reconnexion (bug nom résiduel).
    COMPANY_LOGO: "companyLogo",
    USER_FIRST_NAME: "userFirstName",
    USER_LAST_NAME: "userLastName",
    USER_IMAGE: "userImage"
};

// 19/08/2026 (A6, beta test) — localStorage.setItem coerce undefined/null en
// chaîne "undefined"/"null", qui est truthy et finit dans des <img src> ou des
// URLs API (GET /undefined, /api/.../company/undefined/...). Écriture et lecture
// sont désormais assainies ; la lecture neutralise aussi les valeurs déjà
// contaminées chez les clients existants.
//
// God Mode (SPEC A10) — tant que l'onglet est en mode intervention, ces
// fonctions lisent et écrivent la SURCOUCHE d'identité (sessionStorage, par
// onglet) et JAMAIS le localStorage : la session client personnelle du super
// admin n'est ni lue, ni écrasée, ni vidée. Pas de retombée sur le localStorage
// pour une clé absente de la surcouche — ce serait lire l'identité du super admin
// dans le compte du client. Le jeton lu est celui de l'intervention ; il a sa
// clé propre (`bsr:godmode-token`) et survit à `clearAll`.
const getItem = (key) => {
    let value;
    if (isGodMode()) {
        value = key === LOCAL_STORAGE_KEYS.TOKEN ? getGodModeToken() : overlayGet(key);
    } else {
        value = localStorage.getItem(key);
    }
    return value === 'undefined' || value === 'null' ? null : value;
};

const setItem = (key, value) => {
    const vide = value === undefined || value === null || value === 'undefined' || value === 'null';
    if (isGodMode()) {
        if (key === LOCAL_STORAGE_KEYS.TOKEN) return;
        if (vide) overlayRemove(key);
        else overlaySet(key, value);
        return;
    }
    if (vide) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, value);
};

const removeItem = (key) => {
    if (isGodMode()) {
        if (key !== LOCAL_STORAGE_KEYS.TOKEN) overlayRemove(key);
        return;
    }
    localStorage.removeItem(key);
};

const clearAll = () => {
    // Même périmètre dans les deux modes : les clés d'identité seulement. Le brouillon
    // du wizard et les autres clés hors identité survivent (le vidage complet de la
    // surcouche appartient à abandonGodMode).
    if (isGodMode()) {
        Object.values(LOCAL_STORAGE_KEYS).forEach((key) => {
            if (key !== LOCAL_STORAGE_KEYS.TOKEN) overlayRemove(key);
        });
        return;
    }
    Object.values(LOCAL_STORAGE_KEYS).forEach((key) => {
        localStorage.removeItem(key);
    });
};

export { LOCAL_STORAGE_KEYS, getItem, setItem, removeItem, clearAll };
